import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import { Hidden } from "@material-ui/core";
import axios from 'axios'
import { Button } from '@mui/material';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import LoadingComponent from '../lib/LoadingComponent';
import fontColor from '../lib/fontColor';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthen, setRoles } from '../libs/todoSlice';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getLoadingRedux, setLoadingRedux, getLandingPageWordRedux, setLandingPageWordRedux } from '../libs/themeColorSlice';
import { logoutSession } from '../lib/logoutRedirect';
import Swal from 'sweetalert2';


function Theme_Color() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [cookie, removeCookie] = useCookies(['account'])
  // const [ loading, setLoading ] = useState(false)
  // const [ landingPageWord, setLandingPageWord ] = useState('')

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  const landingPageWord = useSelector(getLandingPageWordRedux)
  const setLandingPageWord = (action) => {
    dispatch(setLandingPageWordRedux({
      landingPageWord: action
    }))
  }

  const createTheme = async (access_token) => {
    const searchParams = new URLSearchParams(document.location.search);
    let formData = new FormData();
  
    // Append other form data fields
    formData.append('biz_id', searchParams.get("biz_id"));
    formData.append('prefix', searchParams.get("prefix"));
    formData.append('primary_color', `rgba(${color.color.r},${color.color.g},${color.color.b},${color.color.a})`);
    formData.append('secondary_color', `rgba(${color.colorSecondary.r},${color.colorSecondary.g},${color.colorSecondary.b},${color.colorSecondary.a})`);
    formData.append('landing_page_wording', landingPageWord); 
    formData.append('service', searchParams.get("service") || "one-id"); 


    setLoading(true);
   
    try {
      let imageLogo = color.logo;
      if (!imageLogo) {
        const response = await fetch(`${window.location.origin}/one-platform.webp`);
        const blob = await response.blob();
        imageLogo = new File([blob], "one-platform.webp", { type: blob.type });
      }
      formData.append('image_logo', imageLogo);
      const { data, status } = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra`,
        data: formData,
      });
  
      setLoading(false);
      const target = `/${searchParams.get("prefix")}/manage-members`
      navigate(target);

    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: 'ระบบขัดข้อง',
        text: 'ระบบขัดข้อง กรุณาติดต่อเจ้าหน้าที่',
        icon: 'error',
        confirmButtonText: 'ปิด',
      })
    }
  };

  const [color, setColor] = useState({
    displayColorPicker: false,
    color: {
      r: '248',
      g: '249',
      b: '250',
      a: '1',
    },
    displayColorPickerSecondary: false,
    colorSecondary: {
      r: '241',
      g: '112',
      b: '19',
      a: '1',
    },
    logo: null
  });


  const handleClick = () => {
    setColor({ ...color, displayColorPicker: !color.displayColorPicker })
  }

  const handleClose = () => {
    setColor({ ...color, displayColorPicker: false })
  };

  const handleChange = (e) => {
    setColor({ ...color, color: e.rgb })
  };

  const handleClickSecondary = () => {
    setColor({ ...color, displayColorPickerSecondary: !color.displayColorPickerSecondary })
  }

  const handleCloseSecondary = () => {
    setColor({ ...color, displayColorPickerSecondary: false })
  };

  const handleChangeSecondary = (e) => {
    setColor({ ...color, colorSecondary: e.rgb })
  };

  const handleChangeImage = (e) => {
    setColor({ ...color, logo: e.target.files[0] })
  }

  const styles = reactCSS({
    'default': {
      color: {
        width: '100px',
        height: '25px',
        borderRadius: '2px',
        background: `rgba(${color.color.r}, ${color.color.g}, ${color.color.b}, ${color.color.a})`,
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
        width: '112px'
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
        top:'32%',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  });

  const stylesSecondary = reactCSS({
    'default': {
      color: {
        width: '100px',
        height: '25px',
        borderRadius: '2px',
        background: `rgba(${color.colorSecondary.r}, ${color.colorSecondary.g}, ${color.colorSecondary.b}, ${color.colorSecondary.a})`,
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
        width: '112px',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  });
  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: '',
    })
  };

  return (
    <div
      style={{
        background: styles.color.background,
        height: '100vh'
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
        {color.logo ?
          <>
            <img
              src={URL.createObjectURL(color.logo)}
              alt="img"
              style={{
                maxWidth: '60px', maxHeight: '60px', margin: '10px 0 10px',
              }} />
            <span
              style={{
                fontWeight: '600',
                color: '#F6911F',
                padding: '10px',
              }}
            >One Platform</span>
          </>
          :
          <>
            <img
              src="/one-platform.png"
              style={{
                maxWidth: '60px', maxHeight: '60px', margin: '10px 0 10px',
              }}
              alt=""
            />
            <span
              style={{
                fontWeight: '600',
                color: '#F6911F',
                padding: '10px',
              }}
            >One Platform</span>
          </>
        }
        <span
          style={{
            float: 'right',
          }}
        >
          <Button
            onClick={() => {
              logout()
            }}
            sx={{
              color: fontColor(stylesSecondary.color.background),
              justifyContent: 'center',
              alignItems: 'center',
              padding: '9px 15px',
              gap: '10px',
              width: '120px',
              height: '36px',
              background: stylesSecondary.color.background,
              borderRadius: '6px',
              float: 'right',
            }}
          >
            ออกจากระบบ
          </Button>
        </span>
      </div>
      <Hidden smDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          {/* <img
            src={color.logo ? URL.createObjectURL(color.logo)  : "/img_create_path.png"}
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          /> */}
        </div>
      </Hidden>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0px 40px',
          gap: '36px',
        }}
      >
        <Card
          style={{
            background: '#C6C7C8',
            borderRadius: '32px',
            color: fontColor(styles.color.background),
            zIndex: '1'
          }}
        >
          <Hidden smDown>
            <div style={{ width: '467px', padding: '60px 40px' }}>
              <div className="col-12 text-center" style={{ paddingBottom: '30px' }}>
                <span
                  style={{
                    fontSize: '34px',
                  }}
                >
                  <b>ออกแบบระบบ</b>
                </span>
              </div>
              <div style={{ display: 'flex', placeContent: 'center' }}>
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: '150px', height: '50px' }}><b>Logo</b></td>
                      <td style={{ height: '50px' }}>
                        <div style={{ textAlign: 'center' }}>
                          <input type="file" id="img" name="img" accept="image/*" className="w-100" onChange={handleChangeImage} />
                          {color.logo &&
                            <img
                              src={URL.createObjectURL(color.logo)}
                              alt="img"
                              style={{
                                maxWidth: '100px', maxHeight: '100px', margin: '10px 0 10px', display: 'flex'
                              }} />
                          }
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: '150px', height: '50px' }}><b>Primary Color</b></td>
                      <td style={{ height: '50px' }}>
                        <div style={styles.swatch} onClick={handleClick}>
                          <div style={styles.color} />
                        </div>
                        {
                          color.displayColorPicker ?
                            <div style={styles.popover}  >
                              <div style={styles.cover} onClick={handleClose} />
                              <SketchPicker color={color.color} onChange={handleChange} />
                            </div> : null
                        }
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: '150px', height: '50px' }}><b>Secondary Color</b></td>
                      <td style={{ height: '50px' }}>
                        <div style={stylesSecondary.swatch} onClick={handleClickSecondary}>
                          <div style={stylesSecondary.color} />
                        </div>
                        {
                          color.displayColorPickerSecondary ?
                            <div style={stylesSecondary.popover}>
                              <div style={stylesSecondary.cover} onClick={handleCloseSecondary} />
                              <SketchPicker color={color.colorSecondary} onChange={handleChangeSecondary} />
                            </div> : null
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className='row'
              >
                <div className="col-12 my-2 text-center">
                  <b>Landing Page Word</b>
                </div>
                <div className="col-12">
                  <ReactQuill
                    style={{
                      height: '120px',
                      color: '#000',
                      background: '#fff',
                    }}
                    value={landingPageWord}
                    theme="snow"
                    onChange={(e) => {
                      setLandingPageWord(e)
                    }}
                  />
                </div>
              </div>
              <div style={{ marginTop: '20px', justifyContent: 'center', display: 'flex' }}>
                <Button
                  variant="contained"
                  style={{ background: stylesSecondary.color.background, borderRadius: '6px', width: '380px', height: '36px', }}
                  onClick={() => {
                    createTheme()
                  }}
                >
                  <span style={{ color: fontColor(stylesSecondary.color.background) }}>Create Theme</span>
                </Button>
              </div>
            </div>
          </Hidden>
          <Hidden mdUp>
            <div style={{ padding: '0px 40px' }}>
              <div className="col-12 text-center" style={{ paddingBottom: '30px' }}>
                <span
                  style={{
                    fontSize: '34px',
                  }}
                >
                  <b>ออกแบบสีระบบ</b>
                </span>
              </div>
              <div style={{ textAlign: '-webkit-center' }}>
                <div>
                  <div className='mb-2'><b>Logo</b></div>
                  <div className='mb-2' style={{ textAlignLast: 'center' }}>
                    <input type="file" id="img" name="img" accept="image/*" className="w-100" onChange={handleChangeImage} />
                    {color.logo &&
                      <img
                        src={URL.createObjectURL(color.logo)}
                        alt="img"
                        style={{
                          maxWidth: '100px', maxHeight: '100px', margin: '10px 0 10px', display: 'flex'
                        }} />
                    }
                  </div>
                </div>
                <div>
                  <div className='mb-2'><b>Primary Color</b></div>
                  <div className='mb-2' style={styles.swatch} onClick={handleClick}>
                    <div style={styles.color} />
                  </div>
                  {
                    color.displayColorPicker ?
                      <div style={styles.popover}>
                        <div style={styles.cover} onClick={handleClose} />
                        <SketchPicker color={color.color} onChange={handleChange} />
                      </div> : null
                  }
                </div>
                <div>
                  <div className='mb-2'><b>Secondary Color</b></div>
                  <div className='mb-2' style={stylesSecondary.swatch} onClick={handleClickSecondary}>
                    <div style={stylesSecondary.color} />
                  </div>
                  {
                    color.displayColorPickerSecondary ?
                      <div style={stylesSecondary.popover}>
                        <div style={stylesSecondary.cover} onClick={handleCloseSecondary} />
                        <SketchPicker color={color.colorSecondary} onChange={handleChangeSecondary} />
                      </div> : null
                  }
                </div>
                <div>
                  <div className='mb-2'><b>Secondary Color</b></div>
                </div>
              </div>
              <div style={{ marginTop: '20px', justifyContent: 'center', display: 'flex' }}>
                {loading ?
                  <LoadingComponent />
                  :
                  <Button
                    variant="contained"
                    style={{ background: stylesSecondary.color.background, borderRadius: '6px', height: '36px', }}
                    onClick={() => { createTheme() }}>
                    <span style={{ color: fontColor(stylesSecondary.color.background) }}>Create Theme</span>
                  </Button>
                }
              </div>
            </div>
          </Hidden>
        </Card>
      </div>
    </div>

  )
}

export default Theme_Color